export class ArrayUtils {
  public static isSameArray(arr1: any[], arr2: any[]): boolean {
    if (!this.isArray(arr1) || !this.isArray(arr2)) {
      return false;
    }

    if (!arr1?.length && arr2?.length) {
      return false;
    }

    if (arr1?.length && !arr2?.length) {
      return false;
    }

    if (arr1?.length !== arr2?.length) {
      return false;
    }

    const sortedArr1 = [...arr1].sort();
    const sortedArr2 = [...arr2].sort();

    for (let i = 0; i < sortedArr1.length; i++) {
      if (sortedArr1[i] !== sortedArr2[i]) {
        return false;
      }
    }

    return true;
  }

  public static isArray(obj: any): boolean {
    return Array.isArray(obj);
  }

  public static getDummyArray(numberOfElement = 5, value: any = null): any[] {
    if (numberOfElement <= 0) {
      return [];
    }
    if (value) {
      return Array(numberOfElement).fill(value);
    } else {
      const toReturn = [];
      for (let i = 0; i < numberOfElement; i++) {
        toReturn.push(i);
      }
      return toReturn;
    }
  }
}
